// CZ: assistance options of an insurer, maintained by the broker as the fleet
// vehicle default setting "assistanceOptions":
//   attributeValue = '["SUPER","51","52"]'
//   settingCriteria = {} (the options apply to all vehicles of the insurer)
// The client picks one of them for the requested Assistance; the coverage
// request (clientCoveragesInfo) stores it as it is defined.

import { FleetDefaultSetting } from "types/types";
import {
  findApplicableClientOptionSetting,
  parseClientOptionList,
} from "./clientOptionSettings";

export const ASSISTANCE_OPTIONS_ATTRIBUTE_NAME = "assistanceOptions";

/** The options of a setting's attributeValue; [] if it is not such a JSON list. */
export const parseAssistanceOptions = (
  attributeValue: string | number | null | undefined,
): string[] =>
  parseClientOptionList(attributeValue).filter(
    (o) => typeof o === "string" && o.trim() !== "",
  );

/**
 * The assistance options the client can pick when the line of the main
 * insurer (MTPL / Hull) is requested from `coverageFrom` ("YYYY-MM-DD"): those
 * of the insurer's "assistanceOptions" setting with the latest valid from date
 * that is not after the coverage start. [] when there is no insurer, no
 * coverage start or no such setting.
 */
export const getAssistanceOptions = (
  fleetDefaultSettings: FleetDefaultSetting[] | null | undefined,
  insurerPartnerNumber: number | string | null | undefined,
  coverageFrom: string | null | undefined,
): string[] => {
  const applicable = findApplicableClientOptionSetting(
    fleetDefaultSettings,
    ASSISTANCE_OPTIONS_ATTRIBUTE_NAME,
    insurerPartnerNumber,
    coverageFrom,
  );
  if (!applicable) return [];
  return Array.from(new Set(parseAssistanceOptions(applicable.attributeValue)));
};
